import Model, { attr } from '@ember-data/model';

export default class ReportScheduleRecord extends Model {
	@attr('number') reportScheduleSettingId!: number;
	@attr('number') scheduledOn!: number;
	@attr('boolean') isSent!: boolean;
	// @attr('array', { defaultValue() { return []; } }) approvedBy!: number[];
	// @attr('number') skippedBy!: number;
	@attr('string') reportUrl!: string; // only for "generate now, send later" case
}
